import get from 'lodash.get';

import { currencies } from 'dibs-currency-helpers';
import { sessionStorage, localStorage } from 'dibs-browser-storage';

// constants
const CURRENCY_STORAGE_KEY = 'userCurrency';

export function isValidCurrency(cur) {
    return !!cur && currencies.includes(cur);
}

function getCurrencyFromStorage() {
    return (
        localStorage.getItem(CURRENCY_STORAGE_KEY) || sessionStorage.getItem(CURRENCY_STORAGE_KEY)
    );
}

export default function getCurrencyPreference({ user, regionalInfo, forcedCurrency }) {
    /*
     * Figure out the correct currency. The correct precedence is
     * 1) currency query param (forced currency prop)
     * 2) logged in user currency preference from service
     * 3) currency from local storage
     * 4) ip address based regionalInfo currency
     * 5) USD
     *
     * Most of these cases will also save the currency to session or local
     * storage so it persists if the user logs out
     */
    let newCurrency = 'USD'; // 5) USD
    const userCurrencyPreference = get(user, 'profile.currency');
    const currencyFromStorage = getCurrencyFromStorage();
    const regionalCurrency = get(regionalInfo, '[0].currency');

    if (isValidCurrency(forcedCurrency)) {
        // 1) currency query param (forced currency prop)
        newCurrency = forcedCurrency;

        // Set currency pref based on the client-requested currency.
        // This is decent UX in practice since we only send the currency
        // param'd PDP links to clients that are geo-targeted to a
        // specific locale. I.e. it's doing the same thing as our
        // regional currency setting.
        sessionStorage.setItem(CURRENCY_STORAGE_KEY, newCurrency);
    } else if (isValidCurrency(userCurrencyPreference)) {
        // 2) logged in user currency preference from service
        newCurrency = userCurrencyPreference;
        localStorage.setItem(CURRENCY_STORAGE_KEY, newCurrency);
    } else if (isValidCurrency(currencyFromStorage)) {
        // 3) currency from local storage
        newCurrency = currencyFromStorage;
    } else if (isValidCurrency(regionalCurrency)) {
        // 4) ip address based regionalInfo currency
        newCurrency = regionalCurrency;
        sessionStorage.setItem(CURRENCY_STORAGE_KEY, newCurrency);
    }

    return newCurrency;
}
